import React from "react";
import { cva } from "class-variance-authority";
import { cn } from "../lib/utils";

const inputVariants = cva(
  "w-full rounded-[16px] border bg-kin-white/80 px-4 text-sm text-kin-black placeholder:text-kin-muted shadow-sm backdrop-blur-md transition-all duration-200 outline-none disabled:cursor-not-allowed disabled:opacity-50",
  {
    variants: {
      variant: {
        default:
          "border-kin-olive/20 focus:border-kin-green/50 focus:ring-4 focus:ring-kin-green/20 focus:bg-kin-white",
        error:
          "border-kin-rose/50 bg-kin-rose/5 focus:border-kin-rose focus:ring-4 focus:ring-kin-rose/20",
        success:
          "border-kin-green/50 bg-kin-green/5 focus:border-kin-green focus:ring-4 focus:ring-kin-green/20",
      },
      size: {
        medium: "h-11",
        large: "h-12",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "medium",
    },
  },
);

const Input = React.forwardRef(({ className, variant, size, ...props }, ref) => (
  <input className={cn(inputVariants({ variant, size, className }))} ref={ref} {...props} />
));

Input.displayName = "Input";

export { Input };
